<template>
    <img :src="require(`@/assets/images/${this.src}`)" class="d-block" :alt="alt">
</template>

<script>
export default {
  name: 'DlImage',
  props: {
    alt: {
      default: 'Logo',
      type: String,
    },
    src: {
      default: 'logo-doctolib-hos.png',
      type: String,
    },
  },
};
</script>